<template>
	<div class="content">
		<div class="section">
			<div class="section-tit">게시판 설정</div>
			<div class="tab-con">
				<div class="txt-c--grey mb-1">
					※ 게시판 탭(카테고리)과 탭별 쓰기 권한 · 확인 버튼 사용 여부를 관리합니다.
					추천매물 게시판(매물 연결)은 코드 추가 시에만 지정할 수 있습니다.
				</div>
				<div class="table-wrap">
					<table class="table">
						<colgroup>
							<col width="9%" /><col width="6%" /><col width="12%" /><col width="17%" />
							<col width="14%" /><col width="10%" /><col width="10%" /><col width="8%" /><col width="14%" />
						</colgroup>
						<tr>
							<th>순서</th>
							<th>번호</th>
							<th>코드</th>
							<th>탭 이름</th>
							<th>쓰기 권한</th>
							<th>확인 버튼</th>
							<th>형식</th>
							<th>사용</th>
							<th>관리</th>
						</tr>
						<tr v-for="(c, idx) in itemList" :key="'bc_' + c.board_category_uid">
							<td>
								<button
									type="button"
									class="btn sort"
									v-if="idx != 0"
									@click="btnOrder(itemList[idx - 1].board_category_uid, c.board_category_uid)"
								>
									<b-icon-arrow-up />
								</button>
								<button
									type="button"
									class="btn sort"
									v-if="idx + 1 != itemList.length"
									@click="btnOrder(c.board_category_uid, itemList[idx + 1].board_category_uid)"
								>
									<b-icon-arrow-down />
								</button>
							</td>
							<td>{{ idx + 1 }}</td>
							<td>{{ c.code }}</td>
							<td><input type="text" class="form-control sm" v-model="c.name" maxlength="50" /></td>
							<td>
								<select v-model="c.write_level" class="form-control select sm">
									<option value="all">전 직원</option>
									<option value="leader">팀장 이상</option>
									<option value="master">관리자만</option>
								</select>
							</td>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" :true-value="'Y'" :false-value="'N'" v-model="c.confirm_flag" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>{{ c.item_flag === 'Y' ? '추천매물' : c.request_flag === 'Y' ? '매수요청' : '-' }}</td>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" :true-value="'Y'" :false-value="'N'" v-model="c.use_flag" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>
								<button type="button" class="btn btn-xsm btn-secondary" @click="btnUpdate(c)">저장</button>
							</td>
						</tr>
						<tr>
							<td colspan="2">추가</td>
							<td><input type="text" class="form-control sm" v-model="addInfo.code" placeholder="영문코드" /></td>
							<td><input type="text" class="form-control sm" v-model="addInfo.name" placeholder="탭 이름" /></td>
							<td>
								<select v-model="addInfo.write_level" class="form-control select sm">
									<option value="all">전 직원</option>
									<option value="leader">팀장 이상</option>
									<option value="master">관리자만</option>
								</select>
							</td>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" :true-value="'Y'" :false-value="'N'" v-model="addInfo.confirm_flag" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" :true-value="'Y'" :false-value="'N'" v-model="addInfo.item_flag" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td colspan="2">
								<button type="button" class="btn btn-xsm btn-primary" @click="btnAdd">추가</button>
							</td>
						</tr>
					</table>
				</div>
				<div class="txt-c--grey mt-1">
					코드는 영문 소문자 · 숫자 · 밑줄 2~30자이며 등록 후 변경할 수 없습니다.
					형식(추천매물=매물 연결, 매수요청=조건 등록+추천 연결)은 등록 후 바꿀 수 없고,
					여기 추가 폼에서는 추천매물 형식만 지정할 수 있습니다.
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SystemAdmin14',
	data() {
		return {
			itemList: [],
			addInfo: { code: '', name: '', write_level: 'all', confirm_flag: 'N', item_flag: 'N' },
		};
	},
	created() {
		this.getItemList();
	},
	methods: {
		getItemList() {
			// all=Y — 관리 화면은 미사용 카테고리도 보여야 다시 켤 수 있다.
			this.$apiGET('/admin/api/board/category?all=Y').then(re => {
				if (!re || !re.list) return;
				this.itemList = re.list;
			});
		},
		btnAdd() {
			if (!this.addInfo.code || !this.addInfo.name) {
				alert('코드와 탭 이름을 입력하세요.');
				return;
			}
			this.$apiPOST('/admin/api/board/category/add', this.addInfo).then(re => {
				if (re !== true) return;
				this.addInfo = { code: '', name: '', write_level: 'all', confirm_flag: 'N', item_flag: 'N' };
				this.getItemList();
			});
		},
		btnUpdate(c) {
			if (!c.name || !c.name.trim()) {
				alert('탭 이름을 입력하세요.');
				return;
			}
			this.$apiPOST('/admin/api/board/category/update', {
				cateUid: c.board_category_uid,
				name: c.name.trim(),
				write_level: c.write_level,
				confirm_flag: c.confirm_flag,
				use_flag: c.use_flag,
			}).then(re => {
				if (re !== true) return;
				this.getItemList();
			});
		},
		btnOrder(u1, u2) {
			this.$apiPOST('/admin/api/board/category/order', { uid_1: u1, uid_2: u2 }).then(re => {
				if (re !== true) return;
				this.getItemList();
			});
		},
	},
};
</script>

<style></style>
